import type { FC } from 'react';
import { Container, SectionSubtitle, SectionText } from '..';
import * as Styled from './styled';
import type { LandingSectionContentProps } from './types';

export const LandingSectionContent: FC<LandingSectionContentProps> = (props) => {
  const { title, subtitle, text, image, imageOnLeft = false, button, children } = props;

  return (
    <Container>
      <Styled.PaddingWrapper>
        <Styled.Title dangerouslySetInnerHTML={{ __html: title }} />
        <Styled.Wrapper>
          <Styled.ContentWrapper>
            {!!subtitle && <SectionSubtitle dangerouslySetInnerHTML={{ __html: subtitle }} />}
            {!!text && <SectionText dangerouslySetInnerHTML={{ __html: text }} />}
            {children}
            {!!button && <>{button}</>}
          </Styled.ContentWrapper>
          <Styled.Image src={image} imageOnLeft={imageOnLeft} />
        </Styled.Wrapper>
      </Styled.PaddingWrapper>
    </Container>
  );
};
